import { Translation } from '@ps/web-shared-components';
import React from 'react';

import StepTwo from '../../../../assets/icons/activestep2.svg';
import CompletedStep from '../../../../assets/icons/completedstep.svg';
import FutureStepThree from '../../../../assets/icons/futurestep3.svg';
import FutureStepBonus from '../../../../assets/icons/futurestepbonus.svg';

import { TXTCLI_About_you } from './StepTwoActive.messages.json';

interface StepTwoActiveProps {
  classname: string;
  hideBonusIcon?: boolean;
}

const StepTwoActive = ({ classname, hideBonusIcon }: StepTwoActiveProps) => (
  <>
    <CompletedStep />
    <div className={classname}>
      <StepTwo />
      <p>
        <Translation {...TXTCLI_About_you} />
      </p>
    </div>
    <FutureStepThree />
    {!hideBonusIcon && <FutureStepBonus />}
  </>
);

export default StepTwoActive;
